import { render, staticRenderFns } from "./HolidayAdd.vue?vue&type=template&id=44a56a4f&lang=pug&"
import script from "./HolidayAdd.vue?vue&type=script&lang=js&"
export * from "./HolidayAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports